const defaultBackend = typeof window !== 'undefined' ? window.location.origin : '';
const backendUrl = (process.env.REACT_APP_BACKEND_URL || defaultBackend || '').replace(/\/$/, '');

export const toAbsoluteImageUrl = (image) => {
  if (!image) return '';

  // If it's already a data URL (base64), return as-is for universal browser support
  if (image.startsWith('data:image')) {
    return image;
  }

  if (image.startsWith('http://') || image.startsWith('https://')) {
    return image;
  }

  const normalizedPath = image.startsWith('/') ? image : `/${image}`;
  return backendUrl ? `${backendUrl}${normalizedPath}` : normalizedPath;
};

export const normalizeProductImages = (product) => ({
  ...product,
  images: (product?.images || []).map((image) => toAbsoluteImageUrl(image))
});

export const normalizeCategoryImage = (category) => ({
  ...category,
  image: toAbsoluteImageUrl(category?.image)
});
